import React, { useState, useEffect, useContext } from 'react';
import { AdminAuthContext } from '../../AdminAuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import './EditUserForm.css';

const EditUserForm = () => {
  const { admin, loading } = useContext(AdminAuthContext); // Changed 'user' to 'admin'
  const { userId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    companyName: '',
    companyNumber: '',
    verified: 0,
    country: '',
    shipping_address: '',
    billing_address: '',
  });
  const [countries, setCountries] = useState([]);
  const [error, setError] = useState(null);
  const [loadingForm, setLoadingForm] = useState(true);

  useEffect(() => {
    if (!loading && admin) {
      // Obtener datos del usuario
      const fetchUser = fetch(`https://valleyapi-dr9y.onrender.com/api/admin/users/${userId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token')}` }, // Changed 'token' to 'admin_token'
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      });

      // Obtener lista de países
      const fetchCountries = fetch('https://valleyapi-dr9y.onrender.com/api/countries', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('admin_token')}` }, // Changed 'token' to 'admin_token'
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      });

      Promise.all([fetchUser, fetchCountries])
        .then(([userData, countriesData]) => {
          setFormData({
            name: userData.name || '',
            email: userData.email || '',
            companyName: userData.companyName || '',
            companyNumber: userData.companyNumber || '',
            verified: userData.verified || 0,
            country: userData.country || '',
            shipping_address: userData.shipping_address || '',
            billing_address: userData.billing_address || '',
          });
          setCountries(countriesData);
          setLoadingForm(false);
        })
        .catch(error => {
          console.error('❌ Error al cargar datos:', error.message);
          setError(`No se pudieron cargar los datos del usuario o los países: ${error.message}`);
          setLoadingForm(false);
        });
    }
  }, [loading, admin, userId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`https://valleyapi-dr9y.onrender.com/api/admin/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (!response.ok) {
        console.error('❌ Respuesta del servidor:', data);
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
      alert('Usuario actualizado exitosamente');
      navigate('/admin/companies');
    } catch (error) {
      console.error('❌ Error al actualizar usuario:', error.message);
      setError(`No se pudo actualizar el usuario: ${error.message}`);
    }
  };

  if (loading || loadingForm) return <div>Loading...</div>;
  if (!admin || admin.role !== 'admin') return <div>Acceso denegado</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="edit-user-form">
      <h2>Editar Usuario</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nombre:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Nombre de la Empresa:</label>
          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Número de la Empresa:</label>
          <input
            type="text"
            name="companyNumber"
            value={formData.companyNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>País:</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un país</option>
            {countries.map(country => (
              <option key={country.idPais} value={country.Country}>
                {country.Country}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>Dirección de Envío:</label>
          <input
            type="text"
            name="shipping_address"
            value={formData.shipping_address}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Dirección de Facturación:</label>
          <input
            type="text"
            name="billing_address"
            value={formData.billing_address}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>
            <input
              type="checkbox"
              name="verified"
              checked={formData.verified === 1}
              onChange={handleChange}
            />
            Verificado
          </label>
        </div>
        <button type="submit">Guardar Cambios</button>
        <button type="button" onClick={() => navigate('/admin/companies')}>
          Cancel
        </button>
      </form>
    </div>
  );
};

export default EditUserForm;